<template>
  <div :id="`iframe.wrapper.${keyId}`" class="r1_iframe_embed">
    <v-progress-circular v-if="loading" class="iframe_loader" color="primary" indeterminate size="35" width="5"/>
  </div>
</template>

<script>
export default {
  name: "videoIframe",

  props: {
    video: Object,
    keyId: Number
  },

  data: () => ({
    loading: false,
  }),

  created() {
    this.loading = true;
    this.setIframe()
  },

  methods: {
    setIframe() {
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.style.border = '0 #ffffff none';
      iframe.name = this.video.name || this.video.title || "video0.mp4"
      iframe.allow = "accelerometer; encrypted-media; gyroscope; picture-in-picture"
      iframe.allowFullscreen = true

      this.$nextTick(() => {
        const holder = document.getElementById(`iframe.wrapper.${this.keyId}`);
        holder.appendChild(iframe);

        iframe.src = this.video.url || this.video.file_link;
        iframe.addEventListener("load", function (event) {
          this.loading = false
          event.target.style.display = "";
        }.bind(this));
      })
    }
  }
}
</script>

<style scoped>
.r1_iframe_embed {
  position: relative;
  overflow: hidden;
  width: 300px;
  height: 170px;
}

.r1_iframe_embed >>> iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.r1_iframe_embed >>> .iframe_loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%);
}
</style>